import { EditOutlined } from '@ant-design/icons';
import PageTitle from 'apps/home/components/PageTitle';
import ErrorMessage from 'common/ui/ErrorMessage';
import { useFetchApiGet } from 'hooks/api';
import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import LoadingSpinner from '../LoadingSpinner';
import UIIconTooltip from '../UIIconTooltip';

const AdminDetail = ({
  title,
  listUrl,
  apiCall,
  options = { title: 'View detail', editEnabled: false },
  ItemDetail,
  resourceName,
}) => {
  const { id } = useParams();
  const { title: actionTitle, editEnabled } = options;

  const {
    data: item,
    isLoading,
    error: fetchItemError,
    load,
    refetch: refreshItem,
  } = useFetchApiGet(apiCall.detail, { resourceName: resourceName || 'data' });

  useEffect(() => {
    if (id) load({ id });
  }, [id]);

  if (isLoading || (!item && !fetchItemError)) {
    return <LoadingSpinner />;
  }

  if (fetchItemError) {
    return <ErrorMessage {...fetchItemError} />;
  }

  return (
    <>
      <PageTitle
        title={title ? `View ${title} detail` : actionTitle}
        backUrl={listUrl}
        extra={
          editEnabled && (
            <Link to={`${listUrl}/${id}/edit`}>
              <UIIconTooltip title="Edit" Icon={EditOutlined} />
            </Link>
          )
        }
      />

      <ItemDetail item={item} apiCall={apiCall} onRefresh={refreshItem} />
    </>
  );
};

export default AdminDetail;
